import type {
  ExperienceDetail,
  ExperienceListItem,
  ExperienceListParams,
} from "@/types/experience";

const API_BASE_URL = "https://www.lilylanka.com";

export async function getExperiences(
  params: ExperienceListParams = {}
): Promise<ExperienceListItem[]> {
  const { category, search, page = 1, pageSize = 20 } = params;

  const query = new URLSearchParams();
  if (category) query.set("category", category);
  if (search) query.set("search", search);
  query.set("page", String(page));
  query.set("pageSize", String(pageSize));

  const res = await fetch(
    `${API_BASE_URL}/api/experiences?${query.toString()}`,
    { cache: "no-store" }
  );

  if (!res.ok) {
    throw new Error(`Failed to fetch experiences: ${res.status} ${res.statusText}`);
  }

  return res.json() as Promise<ExperienceListItem[]>;
}

export async function getExperienceById(
  experienceId: string
): Promise<ExperienceDetail> {
  const res = await fetch(
    `${API_BASE_URL}/api/experiences/${experienceId}`,
    { cache: "no-store" }
  );

  if (!res.ok) {
    throw new Error(`Failed to fetch experience ${experienceId}: ${res.status} ${res.statusText}`);
  }

  return res.json() as Promise<ExperienceDetail>;
}